import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Dashboard from '../../pages/Dashboard/Dashboard';
import PlayerDetails from '../../pages/PlayerDetails/PlayerDetails';
import Expenses from '../../pages/Expenses/Expenses';
import Settlement from '../../pages/Settlement/Settlement';
import NotFound from '../../pages/NotFound/NotFound';
import { PlayerProvider } from '../../context/PlayerContext';
import { ExpenseProvider } from '../../context/ExpenseContext';
import { useSession } from '../../context/SessionContext';
import './SessionApp.scss';

const SessionApp = () => {
  const { sessionId } = useParams();
  const { getSessionById } = useSession();
  
  const currentSession = getSessionById(sessionId);
  
  if (!currentSession) {
    return (
      <div className="session-app">
        <Header />
        <Container maxWidth="lg" className="session-app-container">
          <NotFound />
        </Container>
        <Footer />
      </div>
    );
  }

  return (
    <PlayerProvider sessionId={sessionId}>
      <ExpenseProvider sessionId={sessionId}>
        <div className="session-app">
          <Header sessionName={currentSession.name} sessionId={sessionId} />
          <Container maxWidth="lg" className="session-app-container">
            <Routes>
              <Route path="/" element={<Dashboard sessionName={currentSession.name} />} />
              <Route path="/player/:id" element={<PlayerDetails sessionName={currentSession.name} />} />
              <Route path="/expenses" element={<Expenses sessionName={currentSession.name} />} />
              <Route path="/settlement" element={<Settlement sessionName={currentSession.name} />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Container>
          <Footer />
        </div>
      </ExpenseProvider>
    </PlayerProvider>
  );
};

export default SessionApp;
